import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type VenueIconProps = CreateIconComponentProps;
export const VenueIcon: React.FC<VenueIconProps> = ({
  title = 'Venue',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.6"
      d="M4 11h16l-3.006-5.754c-.111-.21-.308-.283-.474-.178-1.011.648-4.638 2.56-9.04-.027-.166-.094-.355-.022-.463.183L4 11ZM20 11H4v9h16v-9Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="1.6"
      d="M15.169 13.5c.829 0 1.5.627 1.5 1.4V17h-3v-2.1c0-.774.671-1.4 1.5-1.4ZM8.9 13.5c.83 0 1.5.627 1.5 1.4V17h-3v-2.1c0-.774.672-1.4 1.5-1.4Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.6"
      d="m20 11 2 8M4 11l-2 8"
    />
  </CreateIconComponent>
);
